import { createContext } from "react";
import { AuthContextType } from "../../../customTypes"

const AuthContext = createContext<AuthContextType>({
  cancelFlow: Function,
  logout: Function,
  clearStorageRefresh: Function,
  refreshAuthToken: Function
});

export default AuthContext;